import { ChevronRightIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@ui/button";

import { cn } from "@/lib/utils";

// Eyebrow, title and cycle chevron shared by every KPI analysis card.
export const DashboardKpiCardHeader = ({
  className,
  eyebrow,
  onNext,
  title,
}: {
  className?: string;
  eyebrow: string;
  onNext: () => void;
  title: string;
}) => {
  return (
    <Row
      className={cn(
        // Above the chart: a full-bleed bar runs up over this row, and the
        // cycle chevron has to stay clickable underneath it.
        "relative z-40 h-10 shrink-0 items-center justify-between gap-2",
        className,
      )}
    >
      <Column className="min-w-0 gap-0.5">
        <Text className="font-lever-accent text-[9px] font-medium uppercase tracking-wider text-lever-text-label">
          {eyebrow}
        </Text>
        <Text className="lever-heading-h7 truncate">{title}</Text>
      </Column>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6 shrink-0 text-lever-text-label shadow-none hover:bg-lever-surface-neutral hover:text-lever-text-body"
        onClick={onNext}
      >
        <ChevronRightIcon className="h-3.5 w-3.5" />
      </Button>
    </Row>
  );
};
